export const formatPrice = (value) => {
    if (isNaN(value)) return '';
    
    return Number(value)
        .toFixed(2) // Redondea a 2 decimales
        .replace('.', ',') // Reemplaza el punto decimal por una coma
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Agrega puntos como separadores de miles
}

export const inputPrice = (value) => {
    // Permitir números, puntos y comas
    let formattedValue = value.target._value.replace(/[^0-9.,-]/g, ""); 
    return formattedValue;
}

export const parseEuroNumber = (value) => {
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
}